import { render, staticRenderFns } from "./lamb-street-bishops-square.vue?vue&type=template&id=30c4db58&"
import script from "./lamb-street-bishops-square.vue?vue&type=script&lang=js&"
export * from "./lamb-street-bishops-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports